import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminPartnerApplicationsQuery.ts
var r = (r) => t({
	queryKey: e.applications(r),
	fetchPage: (e) => n.listApplications({
		page: e,
		status: r
	}),
	key: "applications"
});
//#endregion
export { r as useAdminPartnerApplicationsQuery };
